// extracted by mini-css-extract-plugin
export default {"root":"singleLayout_root__lguUP"};